import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';

import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { SharedModule } from "../../../shared/shared.module";
import { MatToolbarModule } from "@angular/material/toolbar";
import { LanguageSelectorModule } from '../language-selector/language-selector.module';
import {ThemeBuilderModule} from '../../../../theme-builder/theme-builder.module';
import {MatBadgeModule} from '@angular/material/badge'
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@NgModule({
    declarations: [
        ToolbarComponent
    ],
    imports: [
        RouterModule,
        SharedModule,
        MatToolbarModule,
        MatBadgeModule,
        LanguageSelectorModule,

        ThemeBuilderModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule
    ],
    exports: [
        ToolbarComponent
    ], 
    providers: [LanguageSelectorComponent]
})
export class ToolbarModule {
}
